import React from 'react';
import { useTranslation } from 'react-i18next';
import { Radio, TertiaryButton, PrimaryButton } from '@dev/ee-components';
import { useSecurity } from '@/services/hooks/useSecurity';

import { STEPS, ButtonFooter } from '../..';
import { SourceTypeProps } from '../../ContactsUpload';

export const SourceType = (props: SourceTypeProps): JSX.Element => {
    const { t } = useTranslation();
    const { isReseller } = useSecurity();
    const { currentStep, termsAccepted, sourceType, setSourceType, setCurrentStep } = props;

    return (
        <div>
            <Radio
                id="source-type-radios"
                name="SourceType"
                disabled={currentStep !== STEPS.SOURCE_SELECTION}
                required={true}
                value={sourceType}
                onChange={(e): void => {
                    setSourceType((e.target as HTMLInputElement).value);
                }}
                radios={[
                    {
                        id: 'upload-file-contacts',
                        label: t('uploadfilecontacts'),
                        value: 'upload',
                    },
                    {
                        id: 'upload-type-contacts',
                        label: t('uploadtypecontacts'),
                        value: 'paste',
                    },
                    ...(!isReseller
                        ? [
                              {
                                  id: 'upload-mailchimp-contacts',
                                  label: t('importfrommailchimp'),
                                  value: 'mailchimp',
                                  disableSentenceCase: true,
                              },
                          ]
                        : []),
                ]}
                labelPlacement="end"
            />
            <ButtonFooter>
                <TertiaryButton
                    id="back-button"
                    text={t('back')}
                    onClick={(): void => {
                        setCurrentStep(STEPS.TERMS_CONFIRMATION);
                    }}
                />
                <PrimaryButton
                    id="continue-button"
                    disabled={!termsAccepted}
                    text={t('continue')}
                    onClick={(): void => {
                        setCurrentStep(STEPS.CONTACT_ADDING_METHODS);
                    }}
                />
            </ButtonFooter>
        </div>
    );
};
